import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthModalProvider } from 'context/AuthModalContext';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store/store';
// import store from 'store';
import toast from 'react-hot-toast';
import ToastProvider from 'lib/toastNotification';
import './index.css';

import 'react-loading-skeleton/dist/skeleton.css';

Modal.setAppElement('#root');
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      console.log(error, 'error');
      let message = 'Something went wrong!';
      if (typeof error === 'string') {
        message = error;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.detail) {
        message = error.detail;
      } else if (error?.message) {
        message = error.message;
      } else if (error instanceof Error) {
        message = error.message;
      } else if (typeof error === 'object') {
        message = JSON.stringify(error);
      }

      toast.error(message);
    },
  }),
});

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthModalProvider>
            <App />
          </AuthModalProvider>
        </QueryClientProvider>
      </ToastProvider>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
